import {IUpdateCompanyIdAction} from '../actions/update-company-id'
import {IMobilityState} from '../state'

export type UpdateCompanyIdAction = IUpdateCompanyIdAction

export const updateCompanyIdReducer = (state: IMobilityState, action: UpdateCompanyIdAction) => ({
  ...state,
  maximActivities: {
    ...state.maximActivities,
    companyId: action.companyId,
  },
})
